
import {
  flexRender,
  getCoreRowModel,
  useReactTable,
} from "@tanstack/react-table";



import { TableSkeleton } from "../skeleton/tableSkeleton/TableSkeleton";
import classes from "./table.module.css"

export const Table = ({
  columns=[],
  data = [],
  loading = false,
  isFetching = false,
  mobileHiddenColumns = [],
}) => {
  const table = useReactTable({
    columns,
    data,
    getCoreRowModel: getCoreRowModel(),
  });

  const rows = table.getRowModel().rows;

  return (
    <div className={classes.wrapper}>
      {/* Fetch indicator (refetch only) */}
      {isFetching && !loading && (
        <div className={classes.fetchIndicator}>
          <div className={classes.spinner}></div>
        </div>
      )}

      <div className={classes.tableContainer}>
        <table className={classes.box__modelTable}>
          {/* Header */}
          <thead>
            {table.getHeaderGroups().map((headerGroup) => (
              <tr
                key={headerGroup.id}
                className={classes.box__modelTable__header__row}
              >
                {headerGroup.headers.map((header) => {
                  const hideClass = mobileHiddenColumns.includes(
                    header.column.id
                  )
                    ? classes.hideMobile
                    : "";

                  return (
                    <th
                      key={header.id}
                      className={`${classes.box__modelTable__header__row__cell} ${hideClass}`}
                    >
                      {header.isPlaceholder
                        ? null
                        : flexRender(
                            header.column.columnDef.header,
                            header.getContext()
                          )}
                    </th>
                  );
                })}
              </tr>
            ))}
          </thead>

          {/* Body */}
          <tbody>
            {/* Skeleton */}
            {loading && rows.length === 0 && (
              <TableSkeleton
                columns={columns}
                rows={6}
                mobileHiddenColumns={mobileHiddenColumns}
              />
            )}

            {/* Empty state */}
            {!loading && rows.length === 0 && (
              <tr>
                <td
                  colSpan={columns.length}
                  className={classes.stateCell}
                >
                  No Data Available
                </td>
              </tr>
            )}

            {/* Actual rows */}
            {!loading &&
              rows.map((row) => (
                <tr
                  key={row.id}
                  className={classes.box__modelTable__body__row}
                >
                  {row.getVisibleCells().map((cell) => {
                    const hideClass = mobileHiddenColumns.includes(
                      cell.column.id
                    )
                      ? classes.hideMobile
                      : "";

                    return (
                      <td
                        key={cell.id}
                        className={`${classes.box__modelTable__body__row__data} ${hideClass}`}
                      >
                        {flexRender(
                          cell.column.columnDef.cell,
                          cell.getContext()
                        )}
                      </td>
                    );
                  })}
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};